
export default {
  name: 'VsContainer',
  props: {
    half: {
      type: Boolean,
      default: false
    },
    expand: {
      type: [Boolean, Object],
      default: false
    },
    align: {
      type: [String, Object],
      default: null
    },
    center: {
      type: [Boolean, Object],
      default: true
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  vessel: {
    default: {
      $attrs: 'all',
      $expand: {
        container(value) {
          return value ? false : null
        }
      },
      $half: {
        container(value) {
          return value ? 'half' : true
        }
      },
      $center: {
        marginX(value) {
          return value ? 'auto' : null
        }
      },
      $align: {
        marginX(value) {
          return value ? 'auto' : null
        },
        marginLeft(value) {
          return value == 'left' ? 0 : null
        },
        marginRight(value) {
          return value == 'right' ? 0 : null
        }
      }
    }
  }
}
